import * as yup from "yup";

export const contactFormValidation = (): yup.AnyObjectSchema =>
    yup.object({
        "contact-phone0": yup.string().phone().nullable(),
        "contact-phone1": yup.string().phone().nullable(),
        "contact-phone2": yup.string().phone().nullable(),

        "contact-email0": yup.string().email().nullable(),
        "contact-email1": yup.string().email().nullable(),
    });
